import { PRIORITY } from "@/lib/format";

export function PriorityDot({ priority, showLabel = false }) {
  const p = PRIORITY[priority] || PRIORITY.P4;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`h-2 w-2 rounded-full ${p.dot} ${priority === "P1" ? "pulse-dot" : ""}`} />
      {showLabel && <span className={`text-[11px] font-semibold ${p.text}`}>{p.label}</span>}
    </span>
  );
}
